export function decodeHtmlEntities(value: string): string {
  const documentFragment = new DOMParser().parseFromString(value, "text/html");

  return (
    documentFragment.body.textContent || documentFragment.body.innerText || ""
  );
}

export function isHtmlEmpty(html: unknown): boolean {
  if (!html) {
    return true;
  }

  const temporaryElement = document.createElement("div");
  temporaryElement.innerHTML = String(html);

  return (temporaryElement.textContent?.trim() || "") === "";
}

/**
 * Returns plain text for native titles on truncated comparison cells.
 */
export function comparisonValueTitle(raw: unknown): string {
  if (raw === null || raw === undefined || raw === "") {
    return "-";
  }

  const value = String(raw)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return value || "-";
}
